import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function logout(logout_data) {
    let data = {};
    data.saml_id = window.localStorage.getItem("saml_id");
    data.logout_all = logout_data && logout_data.logout_all ? logout_data.logout_all : false;
    appendTokenName(data);
    return apiAction({
        types: ["LOGOUT_REQUESTED", "LOGOUT_SUCCESS", "LOGOUT_FAILED"],
        method: "POST",
        path: "logout/",
        body: data
    });
}

export function logoutControlled(logout_data) {
    let data = {};
    data.saml_id = window.localStorage.getItem("saml_id");
    data.logout_all = logout_data && logout_data.logout_all ? logout_data.logout_all : false;
    appendTokenName(data);
    return apiAction({
        types: ["LOGOUT_REQUESTED", "LOGOUT_SUCCESS_CONTROLLED", "LOGOUT_FAILED"],
        method: "POST",
        path: "logout/",
        body: data
    });
}

export function loginFunction(login_data) {
    var user_info = {"username": login_data.username};
    // setting username for the user that is needed in all apis
    window.localStorage.setItem("user_info", JSON.stringify(user_info));

    const resp =  apiAction({
        types: ["LOGIN_REQUESTED", "LOGIN_SUCCESS", "LOGIN__FAILED"],
        method: "POST",
        path: "authenticate/",
        credentials: "same-origin",
        body: login_data,
        redirect: "manual"
    });

    return resp;
}

export function get_two_factor(login_data) {
    appendTokenName(login_data);
    return apiAction({
        types: ["AUTH_REQUESTED", "AUTH_SUCCESS", "AUTH_FAILED"],
        method: "POST",
        path: "two_factor_auth/",
        body: login_data
    });
}

export function getNewToken(payload_data){
    return apiAction({
        types: ["GETNEWTOKEN_REQUESTED", "GETNEWTOKEN_SUCCESS", "GETNEWTOKEN_FAILED"],
        method: "POST",
        path: "new_session_token/",
        body: payload_data
    });
}

export function getLoginSettings(){
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SSO_STATUS_REQUESTED", "GET_SSO_STATUS_SUCCESS", "GET_SSO_STATUS_FAILED"],
        method: "POST",
        path: "login_settings/",
        body: data
    });
}

export function sloFunction(){
    let data = {};
    appendTokenName(data);
    data.saml_id = window.localStorage.getItem("saml_id");
    return apiAction({
        types: ["SLO_STATUS_REQUESTED", "SLO_STATUS_SUCCESS", "SLO_STATUS_FAILED"],
        method: "POST",
        path: "saml_logout/",
        body: data
    });
}


export function setSecret(login_data) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    appendTokenName(login_data);
    return apiAction({
        types: ["SET_SECRET_REQUESTED", "SET_SECRET_SUCCESS", "SET_SECRET_FAILED"],
        method: "POST",
        path: "/set_secret",
        body: login_data
    });
}
